"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const Constants_1 = require("../../Constants");
class HangOnComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.hideHangOn = Constants_1.Constants.hideHangOn;
        this.msg = '';
    }
    tell(msg) {
        this.msg = msg;
        // console.log ( "@@@ tell", msg);
        this.update();
    }
    update() {
        this.cdr.detectChanges();
        // console.log ( "@@@ update");
    }
    ngOnInit() {
    }
}
exports.HangOnComponent = HangOnComponent;
